import { cn } from '@utils'
import LinkHome from '../links/home'

export default function Breadcrumb({
  className = '',
  home,
  items,
  children,
}: {
  className?: string
  home?: boolean
  items?: React.ReactNode[]
  children?: React.ReactNode
}) {
  return (
    <nav className={cn('flex items-center gap-x-2 flex-wrap', className)}>
      {home && (
        <BreadcrumbItem slash>
          <LinkHome>Home</LinkHome>
        </BreadcrumbItem>
      )}
      {items?.map((item, index) => (
        <BreadcrumbItem key={index} slash>
          {item}
        </BreadcrumbItem>
      ))}
      {children && <BreadcrumbItem>{children}</BreadcrumbItem>}
    </nav>
  )
}

function BreadcrumbItem({
  children,
  className,
  slash = false,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & {
  slash?: boolean
}) {
  return (
    <>
      <span
        className={cn(
          'text-secondary-light hover:text-font-primary transition-colors whitespace-nowrap',
          className
        )}
        {...props}
      >
        {children}
      </span>
      {slash && (
        <span className='text-secondary-light' aria-hidden>
          &gt;
        </span>
      )}
    </>
  )
}
